import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { t } from "i18next";
import CallUsBlock from "./CallUsBlock/CallUsBlock";
import { EventNames } from "core/monitoring/types/enums";
import { ReportingEventType } from "shared/constants/ReportingEventType";
import { dial } from "core/javascriptChannels";
import { removeSpaces } from "shared/core/utils/string";
import { trackEvents } from "core/monitoring/Events";
import { useLogReportingEventFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import parseHelplineNumbers from "../utils/helpline";

const HelplineBlock = ({ helplineData }: { helplineData: string }) => {
  const { isMobileApp } = useMobilePlatform();
  const { trigger } = useLogReportingEventFunctionRequest();
  const parsedHelplineNumbers = parseHelplineNumbers(helplineData);

  const handleStartPhoneCall = (number: string) => {
    trackEvents(EventNames.PHONE_CALL_START);
    trigger({ body: { reportingEventType: ReportingEventType.SupportRequestPhone } }).finally(() => dial(removeSpaces(number)));
  };

  if (!parsedHelplineNumbers || parsedHelplineNumbers.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <h2 className="ml-5">{t("support.callUs.description")}</h2>
      <div className="flex flex-col gap-4">
        {parsedHelplineNumbers.map(({ number, country }, index: number) => {
          return (
            number && (
              <RoundedCard key={index}>
                <button onClick={isMobileApp ? () => handleStartPhoneCall(number) : undefined} disabled={!isMobileApp} className="flex items-center">
                  <CallUsBlock code={country} number={number} />
                </button>
              </RoundedCard>
            )
          );
        })}
      </div>
    </div>
  );
};

export default HelplineBlock;
